import React from "react";

import { IgPaper, IgPaperColor, IgPaperProps } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";

type BaseGraphPaperProps = IgPaperProps & {
  hideBorder?: boolean;
  color?: IgPaperColor;
};

export const BaseGraphPaper = ({
  children,
  hideBorder,
  sx,
  ...props
}: BaseGraphPaperProps) => {
  const theme = useTheme();
  return (
    <IgPaper
      {...props}
      sx={{
        border: `1px solid ${hideBorder ? "transparent" : theme.igBorders.core.default} !important`,
        padding: "20px !important",
        backgroundColor: theme.igBackgroundColors.baseLightHigh,
        borderRadius: "6px",
        width: "100%",
        ...sx,
      }}
    >
      {children}
    </IgPaper>
  );
};
